import { render } from "./LicenseApplicationAnswersModal.vue?vue&type=template&id=50f7059c"
import script from "./LicenseApplicationAnswersModal.vue?vue&type=script&lang=js"
export * from "./LicenseApplicationAnswersModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__